<template>
    <div v-if="inline" :id="id"></div>
    <div v-else class="form-group">
        <div class="input-group date cal-month-year" :id="id" data-target-input="nearest" >
            <input type="text" class="form-control datetimepicker-input" :data-target="idhash" :id="id + '_input'"/>
            <span class="input-group-addon" :data-target="idhash" data-toggle="datetimepicker">
                <span class="glyphicon glyphicon-calendar"></span>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'datetime',
        data() {
            return {
                datetime: null,
                id: null,
                idhash: null,
            }
        },
        computed: {
            translation() {
                if(this.$i18n.locale() == 'en')
                {
                    return "English Translation";
                }
                else
                {
                    return "Spanish Translation";
                }
            }
        },
        props: {
            value: {default: null},
            format: {default: null},
            locale: {default: null},
            inline: {default: true},
            sideBySide: {default: true},
            useCurrent: {default: true}
        },
        // watch: {
        //     value(newVal, oldVal)
        //     {
        //         this.datetime.datetimepicker({locale: this.locale, format: this.format, defaultDate: newVal, inline: this.inline, sideBySide: true});
        //     }
        // },
        methods: {
            changed(e)
            {
                if(e.date !== null && e.date !== undefined) {
                    this.$emit('input', e.date.format("YYYY-MM-DD HH:mm:ss"));
                } else {
                    this.$emit('input', "");
                }
            },
        },
        mounted() {
            this.id = function guid() {
                function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000)
                        .toString(16)
                        .substring(1);
                }
                return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                    s4() + '-' + s4() + s4() + s4();
            }();

            this.idhash = '#' + this.id;
           
            this.$nextTick(() => {
                this.datetime = $('#' + this.id);
                if(this.value === null || this.value === '') {
                    this.datetime.datetimepicker({useCurrent: this.useCurrent, format: this.format, locale: this.locale, inline: this.inline, sideBySide: this.sideBySide, allowInputToggle: true});
                } else {
                    this.datetime.datetimepicker({date: this.value, useCurrent: this.useCurrent, format: this.format, locale: this.locale, inline: this.inline, sideBySide: this.sideBySide, allowInputToggle: true});
                }
                this.datetime.on('change.datetimepicker', this.changed);
            });
        },
    }
</script>
